<template>
  <div data-app :v-if="loadingAvailable == false">
    <div
      role="alert"
      v-bind:class="{ show: errors.length }"
      class="alert fade alert-danger"
    >
      <div class="alert-text" v-for="(error, i) in errors" :key="i">
        {{ error }}
      </div>
    </div>

    <div class="alert alert-warning d-flex align-items-center">

      <div class="alert-text">

    <v-icon class="mr-1">mdi-alert</v-icon> <!-- Warning Icon -->
        <strong>Deprecated:</strong> Consider using the "Filter Configurations" page to create reusable filters, and then referencing those directly via rules with the action "filter" from the "Firewall Rules" page
      </div>
    </div>

    <div v-show="Object.keys(filtersAvailable).length >= 1">
      <template v-for="{ name, label, description } in filtersAvailable">
        <v-card :key="`card-${name}`" class="mb-5">
          <v-card-title :key="`table-title-${name}`"
            >Filters for {{ label }}</v-card-title
          >
          <v-card-subtitle :key="`table-subtitle-${name}`">{{
            description
          }}</v-card-subtitle>

          <v-data-table
            :key="`table-${label}`"
            v-model="selected"
            :loading="loading"
            :headers="headers[name]"
            :search="search"
            :items="
              filters.filter((obj) => {
                return obj.name == name;
              })
            "
            :footer-props="{
              itemsPerPageOptions: [5, 10, 50, 100, 250, -1], // -> Add this example
              showFirstLastPage: false,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-chevron-left',
              nextIcon: 'mdi-chevron-right',
            }"
            item-key="id"
            class="elevation-1"
          >
            <template v-slot:item.settings.ports="{ item }">
              <template v-for="ports in item.settings.ports">
                <div :key="ports">{{ ports[0] }} => {{ ports[1] }} <br /></div>
              </template>
            </template>

            <template v-slot:item.settings.port_range="{ item }">
              <div>
                {{ item.settings.port_range[0] }} =>
                {{ item.settings.port_range[1] }} <br />
              </div>
            </template>

            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="filterDialog[name]" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      v-on="on"
                      @click="newItem(name, label)"
                      >New Filter</v-btn
                    >
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row dense="">
                          <!-- <div v-if="editedItem.filter"> -->

                          <template
                            v-for="{
                              value,
                              name,
                              label,
                              description,
                              example,
                            } in filtersAvailable[name].fields"
                          >
                            <v-col
                              :key="`field-${label}`"
                              cols="12"
                              sm="6"
                              md="11"
                            >
                              <v-select
                                v-if="value.type == 'select'"
                                v-model="editedItem.fields[name]"
                                :items="value.options"
                                :label="label"
                                item-text="label"
                                item-value="value"
                                editable
                                aria-required=""
                                :key="`field-${label}`"
                              />

                              <v-text-field
                                v-if="value.type === 'ip'"
                                :type="value.type"
                                :name="name"
                                :label="label"
                                :hint="description"
                                :placeholder="example"
                                :rules="ipRules"
                                v-model="editedItem.fields[name]"
                                :key="`field-${label}`"
                                persistent-hint
                              />

                              <v-text-field
                                v-if="value.type === 'cidr'"
                                :type="value.type"
                                :name="name"
                                :label="label"
                                :hint="description"
                                :placeholder="example"
                                :rules="ipRules"
                                v-model="editedItem.fields[name]"
                                :key="`field-${label}`"
                                persistent-hint
                              />

                              <v-checkbox
                                v-if="value.type === 'bool'"
                                :type="value.type"
                                :name="name"
                                :label="label"
                                :hint="description"
                                v-model="editedItem.fields[name]"
                                :key="`field-${label}`"
                                persistent-hint
                              />

                              <v-text-field
                                v-if="value.type === 'text'"
                                :type="value.type"
                                :name="name"
                                :label="label"
                                :hint="description"
                                :placeholder="example"
                                :rules="ipRules"
                                v-model="editedItem.fields[name]"
                                :key="`field-${label}`"
                                persistent-hint
                              />

                              <v-text-field
                                v-if="value.type === 'port'"
                                :type="value.type"
                                :name="name"
                                :label="label"
                                :hint="description"
                                :placeholder="example"
                                :rules="validPort"
                                v-model="editedItem.fields[name]"
                                :key="`field-${label}`"
                                persistent-hint
                              />

                              <v-text-field
                                v-if="value.type == 'integer'"
                                :type="value.type"
                                :name="name"
                                :label="label"
                                :hint="description"
                                :placeholder="example"
                                :rules="[
                                  withinRange(
                                    value,
                                    value.min || 0,
                                    value.max || 0
                                  ),
                                ]"
                                v-model="editedItem.fields[name]"
                                :key="`field-${label}`"
                                persistent-hint
                              />

                              <textarea
                                v-if="value.type === 'textarea'"
                                :name="name"
                                :placeholder="example"
                                :label="label"
                                :hint="description"
                                :id="name"
                                v-model="editedItem.fields[name]"
                                :key="`field-textarea-${label}`"
                                persistent-hint
                              >
                              </textarea>

                              <div v-if="value.type === 'port_range'">
                                <v-row :key="`field-array-row-1`">
                                  <v-col :key="`field-array-start-1`" cols="6">
                                    <v-text-field
                                      :key="`field-array-1`"
                                      :rules="validPort"
                                      v-model="editedItem.fields[name][0]"
                                      label="Port Start (Inclusive)"
                                      placeholder="1"
                                    />
                                  </v-col>
                                  <v-col :key="`field-array-end-1`" cols="5">
                                    <v-text-field
                                      :key="`field-array-end-1`"
                                      :rules="validPort"
                                      v-model="editedItem.fields[name][1]"
                                      label="Port End (Inclusive)"
                                      placeholder="65535"
                                    />
                                  </v-col>
                                  <v-col :key="`field-array-del-1`" cols="1">
                                  </v-col>
                                </v-row>
                              </div>

                              <div
                                v-if="
                                  value.type === 'array' &&
                                  value.subtype.type === 'port_range'
                                "
                              >
                                <template
                                  v-for="(value, index) in editedItem.fields[
                                    name
                                  ]"
                                >
                                  <v-row :key="`field-array-row-${index}`">
                                    <v-col
                                      :key="`field-array-start-${index}`"
                                      cols="6"
                                    >
                                      <v-text-field
                                        :key="`field-array-${index}`"
                                        :rules="validPort"
                                        v-model="value[0]"
                                        label="Port Start (Inclusive)"
                                        placeholder="1"
                                      />
                                    </v-col>
                                    <v-col
                                      :key="`field-array-end-${index}`"
                                      cols="5"
                                    >
                                      <v-text-field
                                        :key="`field-array-end-${index}`"
                                        :rules="validPort"
                                        v-model="value[1]"
                                        label="Port End (Inclusive)"
                                        placeholder="65535"
                                      />
                                    </v-col>
                                    <v-col
                                      :key="`field-array-del-${index}`"
                                      cols="1"
                                    >
                                      <v-btn
                                        color="blue darken-1"
                                        @click="deletePort(index)"
                                        :disabled="index == 0"
                                        height="50px"
                                        ><v-icon small
                                          >mdi-delete</v-icon
                                        ></v-btn
                                      >
                                    </v-col>
                                  </v-row>
                                </template>

                                <v-btn
                                  color="blue darken-1"
                                  text
                                  @click="addMorePort(name)"
                                  :disabled="
                                    editedItem.fields['ports'].length >=
                                    value.max_length
                                  "
                                  >More</v-btn
                                >
                              </div>
                            </v-col>
                          </template>

                          <!-- </div> -->
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click.stop="close(name)"
                        >Cancel</v-btn
                      >
                      <v-btn color="blue darken-1" text @click="save(name)"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-card>
      </template>
    </div>

    <div v-show="Object.keys(filtersAvailable).length == 0">
      <v-card>
        <v-card-title>No filters available for this account</v-card-title>
      </v-card>
    </div>
  </div>
</template>

<script>
import api from "@/common/api.service";
import Errors from "@/common/errors";
import ipAddr from "ip-address";

export default {
  mounted() {
    api
      .query("filters")
      .then((response) => (this.filters = response.data.filters))
      .catch((error) => this.errors.push(...Errors.extractErrorMessage(error)))
      .finally(() => (this.loading = false));

    api
      .query("filters/available")
      .then((response) => {
        for (var key in response.data.filters) {
          var filter = response.data.filters[key];
          var tmp = {
            name: filter.name,
            label: filter.label,
            description: filter.description,
            fields: {},
          };
          var t = [
            {
              text: "ID",
              align: "left",
              sortable: false,
              value: "id",
            },
          ];
          for (var i in filter.fields) {
            var field = filter.fields[i];

            t.push({
              text: field.label,
              value: "settings." + field.name,
            });
            tmp["fields"][field.name] = field;
          }
          t.push({ text: "Actions", value: "actions", sortable: false });
          this.headers[filter.name] = t;
          this.$set(this.filterDialog, filter.name, false);
          this.filtersAvailable[filter.name] = tmp;
        }
      })
      .catch((error) => (this.errors = [error]))
      .finally(() => (this.loadingAvailable = false));
  },
  data: () => ({
    selected: [],
    headers: {},
    filters: [],
    filtersAvailable: {},
    errors: [],
    loading: true,
    loadingAvailable: true,
    newItemType: "",
    filterDialog: {},
    ipRules: [
      (v) => !!v || "IP address is required",
      (v) =>
        (!!v &&
          (new ipAddr.Address4(v).isValid() ||
            new ipAddr.Address6(v).isValid())) ||
        "IP address is invalid",
    ],
    validPort: [
      (v) =>
        !v ||
        (parseInt(v) !== NaN && parseInt(v) > 0 && parseInt(v) < 65536) ||
        "Must be between 1 and 65535",
    ],
    withinRange: (v, min, max) =>
      !v ||
      (!min && !max) ||
      (parseInt(v) !== NaN && parseInt(v) >= min && parseInt(v) <= max) ||
      `Must be between ${min} and ${max}`,
    editedIndex: -1,
    editedItem: {
      id: "",
      fields: {
        ports: [[]],
        port_range: [],
      },
      comment: "",
    },
    defaultItem: {
      id: "",
      fields: {
        ports: [[]],
        port_range: [],
      },
      comment: "",
    },
    search: "",
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New filter" : "Editing filter";
    },
  },
  methods: {
    addMorePort(_item, _name) {
      if (
        this.editedItem.fields["ports"].length >
        this.filtersAvailable[this.newItemType]["fields"]["ports"]["value"][
          "max_length"
        ]
      ) {
        return;
      }

      this.editedItem.fields["ports"].push([]);
    },

    deletePort(id) {
      if (
        this.editedItem.fields["ports"].length <
        this.filtersAvailable[this.newItemType]["fields"]["ports"]["value"][
          "min_length"
        ]
      ) {
        return;
      }

      this.editedItem.fields["ports"].splice(id, 1);
    },

    newItem(name, label) {
      this.newItemName = label;
      this.newItemType = name;
      this.filterDialog[name] = true;

      // `this` can't be accessed from within the `forEach`
      const filter = this.filtersAvailable[this.newItemType];
      const editedItem = this.editedItem;

      Object.keys(filter.fields).forEach(function (key, _index) {
        const defaultValue = filter.fields[key].value.default;
        if (defaultValue !== null) editedItem.fields[key] = defaultValue;
      });

      this.editedItem = Object.assign({}, editedItem);
      // This field gets lost for whatever reason and the "More" button is
      // dependent on it, so manually re-add it
      this.editedItem.fields["ports"] = [[]];
      this.editedItem.fields["port_range"] = [];
    },

    editItem(item) {
      this.editedIndex = this.filters.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      if (confirm("Are you sure you want to delete this item?")) {
        api.delete("filters/" + item.name + "/" + item.id).then((response) => {
          const index = this.filters.indexOf(item);
          this.filters.splice(index, 1);
        });
      }
    },

    close(name) {
      this.$set(this.filterDialog, name, false);
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save(name) {
      api
        .post("filters/" + name, this.editedItem.fields)
        .then((response) => {
          this.filters.unshift(response.data);
        })
        .catch((error) => this.errors.push(...Errors.extractErrorMessage(error)))
        .finally(() => this.close(name));
    },
  },
};
</script>
